import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authServices";

const getUserfromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
  // console.log("User from localStorage:", getUserfromLocalStorage.data._id);

const initialState = {
  user: getUserfromLocalStorage,
  adminId: getUserfromLocalStorage?.data?._id || null, // Extract the admin's I
  orders: [],
  // profile: null, 
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const login = createAsyncThunk(
  "auth/login",
  async (userData, { rejectWithValue }) => {
    try {
      return await authService.login(userData);
    } catch (error) {
      return rejectWithValue({
        message:
          error.response?.data?.message ||
          error.message ||
          "Login failed",
      });
    }
  }
);

export const getOrders = createAsyncThunk(
  "order/orders",
  async (thunkAPI) => {
    try {
      return await authService.getOrders();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// export const getOrderByUser = createAsyncThunk(
//   "order/get-order",
//   async (id, thunkAPI) => {
//     try {
//       return await authService.getOrder(id);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const getOrderByUser = createAsyncThunk(
  "order/get-order",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await authService.getOrder(userId);
      return response; // Return the response data
    } catch (error) {
      // Extract only serializable parts of the error
      return rejectWithValue({
        message: error.message,
        code: error.code,
        response: error.response?.data,
      });
    }
  }
);

// export const getProfile = createAsyncThunk(
//   "admin/getProfile",
//   async (_, thunkAPI) => {
//     try {
//       const response = await authService.getProfile();
//       return response; // Return the profile data
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch profile");
//     }
//   }
// );

// export const getProfile = createAsyncThunk(
//   "admin/getProfile",
//   async (adminId, thunkAPI) => {
//     try {
//       const response = await authService.getProfile(adminId); // Pass the adminId
//       console.log("adminId", response);
//       return response; // Return the profile data
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch profile");
//     }
//   }
// );

export const getProfile = createAsyncThunk(
  "admin/getProfile",
  async (adminId, thunkAPI) => {
    try {
      const response = await authService.getProfile(adminId);
      return response; // Return the profile data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch profile");
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  // initialState: initialState,
  reducers: {
    resetState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (buildeer) => {
    buildeer
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.message = "success";
      })
      .addCase(login.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload?.message || "Login failed";
        state.isLoading = false;
      })
      .addCase(getOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.orders = action.payload.data;
        state.message = "success";
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      // .addCase(getOrderByUser.pending, (state) => {
      //   state.isLoading = true;
      // })
      // .addCase(getOrderByUser.fulfilled, (state, action) => {
      //   state.isError = false;
      //   state.isLoading = false;
      //   state.isSuccess = true;
      //   state.orderbyuser = action.payload;
      //   state.message = "success";
      // })
      // .addCase(getOrderByUser.rejected, (state, action) => {
      //   state.isError = true;
      //   state.isSuccess = false;
      //   state.message = action.error;
      //   state.isLoading = false;
      // });

      .addCase(getOrderByUser.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.message = "";
      })
      .addCase(getOrderByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orderbyuser = [action.payload];
      })
      .addCase(getOrderByUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload?.message || "Failed to fetch order.";
      })
      .addCase(getProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        console.log("Profile data fetched successfully:", action.payload);
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.profile = action.payload.data; // Store profile data
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetState } = authSlice.actions;

export default authSlice.reducer;
